"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function LoadingThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M8,1 L8,2 L8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,5.25858657 12.1614578,2.94658768 9.65013718,2.22976717 L9.92410039,1.26775933 C12.8545169,2.10370195 15,4.80129876 15,8 C15,11.8659932 11.8659932,15 8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 Z" })));
}
exports.default = LoadingThin;
//# sourceMappingURL=LoadingThin.js.map